var styleDataHash = '469cfb60';  
export const injectCss = (() => {
  var css = `.aeZ5t{align-items:center;box-sizing:border-box;color:var(--ricos-settings-text-color,#000);display:flex;font-size:20px;justify-content:space-between;max-width:420px;position:absolute;top:0;width:100%;z-index:2}[dir] .aeZ5t{background-color:#fff;padding:24px}[dir=ltr] .aeZ5t{left:0}[dir=rtl] .aeZ5t{right:0}.aeZ5t ._7Z3mp{fill:var(--ricos-settings-icons-color,#000)}[dir] .aeZ5t ._7Z3mp{cursor:pointer}.aeZ5t ._7Z3mp:hover{opacity:.5}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "settingsPanelHeader": "aeZ5t",
  "settingsPanelHeader_closeIcon": "_7Z3mp"
};